import React, {Component} from 'react';

class MonitorCanvas extends Component {
  canvas = React.createRef();
  canvasStyle = {
    zIndex: 2,
    position: 'absolute',
    top: 0,
    left: 0,
  };

  frameId = null;
  particles = [];
  prevWidth = 0;
  prevHeight = 0;
  ctx = null;
  state = {width: 0, height: 0};

  componentDidMount() {
    this.updateCanvas();
  }

  componentDidUpdate() {
    const {particles} = this.props;
    const {width, height} = this.state;

    if (this.frameId) {
      window.cancelAnimationFrame(this.frameId);
    }

    this.particles = particles.map(particle => {
      const createdItem = this.create();
      createdItem.init(particle.x, particle.y, particle.cdn);
      return createdItem;
    });

    this.animate(this.ctx, this.particles, width, height);
  }

  componentWillUnmount() {
    if (this.frameId) {
      window.cancelAnimationFrame(this.frameId);
    }
  }

  updateCanvas = () => {
    const parentWidth = this.canvas.current.parentNode.clientWidth;
    const parentHeight = this.canvas.current.parentNode.clientHeight;

    this.ctx = this.canvas.current.getContext('2d');
    this.ctx.globalCompositeOperation = 'lighter';

    this.prevWidth = this.state.width;
    this.prevHeight = this.state.height;

    this.updateSize(parentWidth, parentHeight);
  };

  updateSize = (paramWidth, paramHeight) => {
    this.setState({
      width: paramWidth,
      height: paramHeight
    });
  };

  create = () => {
    const { width, height } = this.state;

    return {
      init(x, y, cdn) {
        const calcX = x;
        const calcY = y;
        this.angle = Math.atan2(calcY, calcX);
        this.width = 54.666667;
        this.height = 54.666667;
        this.xxx = (this.width / 2) * Math.cos(this.angle);
        this.yyy = (this.height / 2) * Math.sin(this.angle);
        this.initialX = Math.round(width / 2 + calcX);
        this.initialY = Math.round(height / 2) + Math.round(width * 0.33) - calcY;
        this.lineX1 = Math.round(width / 2);
        this.lineY1 = Math.round(height / 2) + Math.round(width * 0.33);
        this.lineX2 = this.initialX - this.xxx;
        this.lineY2 = this.initialY + this.yyy;
        this.particleX = this.initialX - Math.round(this.width / 2);
        this.particleY = this.initialY - Math.round(this.height / 2);
        this.particleCdn = cdn;

        this.direction = {
          x: -1 + Math.random() * 2,
          y: -1 + Math.random() * 2
        };

        this.vx = (5 * Math.random() + 5) * 0.01;
        this.vy = (5 * Math.random() + 5) * 0.01;
      },
      move() {
        this.lineX2 += this.vx * this.direction.x;
        this.lineY2 += this.vy * this.direction.y;
        this.particleX += this.vx * this.direction.x;
        this.particleY += this.vy * this.direction.y;
      },
      boundaryCheck() {
        if (Math.abs((this.initialX - this.xxx) - this.lineX2) >= 5) {
          this.direction['x'] *= -1
        }
        if (Math.abs((this.initialY + this.yyy) - this.lineY2) >= 5) {
          this.direction['y'] *= -1
        }
      }
    }
  };

  animate = (ctx, particles, canvasWidth, canvasHeight) => {
    // Clear canvas before drawing
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    particles.forEach((particle) => {
      this.draw(ctx, particle);
    });
    particles.forEach((particle) => {
      particle.move();
      particle.boundaryCheck();
    });

    this.frameId = window.requestAnimationFrame(() => this.animate(ctx, particles, canvasWidth, canvasHeight));
  };


  draw = (ctx, particle) => {
    const {
      width,
      height,
      particleX,
      particleY,
      particleCdn,
      lineX1,
      lineX2,
      lineY1,
      lineY2,
    } = particle;

    ctx.save();
    // line
    ctx.beginPath();
    ctx.moveTo(lineX1, lineY1);
    ctx.lineTo(lineX2, lineY2);
    const gradient = this.ctx.createLinearGradient(lineX1, lineY1, lineX2, lineY2);
    gradient.addColorStop(0, 'rgba(255, 255, 255, 0)');
    gradient.addColorStop(.5, 'rgba(255, 255, 255, 0.6)');
    gradient.addColorStop(1, 'rgba(255, 255, 255, 1)');
    ctx.strokeStyle = gradient;
    ctx.lineWidth = 0.5;
    ctx.stroke();
    ctx.closePath();
    // particle
    const img = new Image(width * 2, height * 2);
    img.src = particleCdn;
    ctx.drawImage(img, particleX, particleY, width, height);
    ctx.restore();
  };

  render() {
    const {width, height} = this.state;

    return (
      <canvas
        ref={this.canvas}
        width={width}
        height={height}
        style={this.canvasStyle}
      />
    );
  }
}

export default MonitorCanvas;


// WEBPACK FOOTER //
// ./src/app/intro/components/MonitorCanvas/MonitorCanvas.js